import Header from "components/Header"
import Footer from "components/Footer"

export default function Favoritos(){
    return(
        <div>
            <Header/>
            <Footer/>

        </div>
    )
}